import { useEffect } from "react";
import { Stack, Button } from "@mui/material";
import { Text } from "@src/lib/ui-react";
import { NearbyWorkerSearchResult } from "../Autocomplete/useGetNearbyWorkers";
import { logEvent } from "@src/appV2/lib/analytics";
import { HCF_USER_EVENTS } from "@src/constants/analyticsEvents";
import { useWorkplaceIds } from "@src/appV2/api/useWorkplaceIds";

interface BlockedWorkerMessageProps {
  selectedWorker: NearbyWorkerSearchResult;
  onInviteSomeoneElse: () => void;
}

export function BlockedWorkerMessage({
  selectedWorker,
  onInviteSomeoneElse,
}: BlockedWorkerMessageProps) {
  const { workerId, fullName: workerName } = selectedWorker;
  const { workplaceId, workplaceUserId } = useWorkplaceIds();

  useEffect(() => {
    logEvent(HCF_USER_EVENTS.SHIFT_INVITE, {
      action: "BLOCKED_WORKER_INVITE_PREVENTED",
      workerId,
      workerName,
      workplaceId,
      workplaceUserId,
    });
  }, [workerId, workerName, workplaceId, workplaceUserId]);

  return (
    <Stack spacing={2} sx={{ marginTop: 2 }}>
      <Text bold variant="body2">
        This professional has been blocked by your workplace and cannot be invited.
      </Text>
      <Text variant="body2">Please invite a different professional.</Text>
      <Stack spacing={1} direction="row" justifyContent="flex-end">
        <Button onClick={onInviteSomeoneElse} variant="contained">
          Invite Someone Else
        </Button>
      </Stack>
    </Stack>
  );
}
